import React from 'react';

import { GroupItemAvatarBadgeElement } from '../styles';

import { GroupItemAvatarBadgeIcon } from './BadgeIcon';

export interface GroupItemAvatarBadgeProps {
    type: 'member' | 'owner';
}

export const GroupItemAvatarBadge = ({ type }: GroupItemAvatarBadgeProps) => {
    return (
        <GroupItemAvatarBadgeElement type={type}>
            <GroupItemAvatarBadgeIcon />
        </GroupItemAvatarBadgeElement>
    );
};
